/**
 * Envision customizations
 * assets/spice-club-product.js
 *
 * Spice Club product page scripts
 */

/**
 * Add character count to the Gift Subscripton form message
 */

(function () {
  const giftSubscriptionMessage = document.querySelector("#GiftSubcriptionMessage");

  if (giftSubscriptionMessage) {
    const maxLength = giftSubscriptionMessage.getAttribute("maxlength");
    const currentLength = giftSubscriptionMessage.value.length;
    const charCount = document.createElement('div');
    charCount.classList.add('char__count');
    charCount.textContent = `${currentLength}/${maxLength}`
    giftSubscriptionMessage.parentElement.append(charCount);
    giftSubscriptionMessage.addEventListener("input", e => {
      const currentLength = giftSubscriptionMessage.value.length;
      charCount.textContent = `${currentLength}/${maxLength}`
    });
  }
})();

/**
 * Add delivery date buttons to the Gift Subscription form similar to the Gift Card's
 */

(function () {
  const giftSubscriptionForm = document.querySelector(".gift-subscription__form");
  if (giftSubscriptionForm) {
    const sendNowButton = giftSubscriptionForm.querySelector(".gift-subscription__send-now--button");
    const sendLaterButton = giftSubscriptionForm.querySelector(".gift-subscription__send-later--button");
    const datePicker = giftSubscriptionForm.querySelector(".gift-subscription__date-picker");
    const addToCartBtn = document.querySelector('button[type="submit"][data-add-to-cart-text].btn');
  
    let datePickerActive = false;
    sendNowButton.addEventListener("click", function (e) {
      e.preventDefault();
      datePicker.valueAsDate = new Date();
      datePicker.style.display = "none";
      sendNowButton.classList.add("active__delivery-option");
      sendLaterButton.classList.remove("active__delivery-option");
      sendNowButton.setAttribute("aria-pressed", "true");
      sendLaterButton.setAttribute("aria-pressed", "false");
      datePickerActive = false;
    });
    sendLaterButton.addEventListener("click", function (e) {
      e.preventDefault();
      datePicker.style.display = "block";
      sendLaterButton.classList.add("active__delivery-option");
      sendNowButton.classList.remove("active__delivery-option");
      sendLaterButton.setAttribute("aria-pressed", "true");
      sendNowButton.setAttribute("aria-pressed", "false");
      datePicker.focus();
      datePicker.click();
    });
    if (datePicker && addToCartBtn) {
      datePicker.addEventListener('change', function() {
        console.log('Selected date:', datePicker.value);
        addToCartBtn.focus();
      });
    }
    if (window.innerWidth > 749) {
      datePicker.addEventListener("click", function (e) {
        e.preventDefault();
        if (datePickerActive) {
          datePicker.blur();
          datePickerActive = false;
        } else {
          datePickerActive = true;
        }
      });
    }
  }
})();

/**
 * Shared validators for gift subscription form
 */
const GIFT_EMAIL_PATTERN = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

function validateGiftField(input) {
  const id = input.getAttribute('id');
  const form = input.closest('.gift-subscription__form') || document;
  const label = id ? form.querySelector('label[for="' + id + '"]') : null;
  let inputLabel = label ? label.textContent.trim() : input.getAttribute('name') || 'Field';
  inputLabel = inputLabel.replace(/\s*\*+\s*$/, '');

  let errorEl = input.parentElement.querySelector('.gift-subscription__error-message');
  if (!errorEl) {
    errorEl = document.createElement('div');
    errorEl.className = 'gift-subscription__error-message';
    errorEl.setAttribute('role', 'alert');
    errorEl.dataset.generated = 'true';
    input.insertAdjacentElement('afterend', errorEl);
  }

  // Reset state by default
  errorEl.textContent = '';
  errorEl.style.display = 'none';
  input.classList.remove('error');
  input.removeAttribute('aria-invalid');

  const value = (input.value || '').trim();

  // Required check
  if (input.hasAttribute('required') && !value) {
    const message = inputLabel + ' is required.';
    errorEl.textContent = message;
    errorEl.style.display = 'block';
    input.classList.add('error');
    input.setAttribute('aria-invalid', 'true');
    return false;
  }

  // Email format check
  if (input.type === 'email' && value && !GIFT_EMAIL_PATTERN.test(value)) {
    const message = 'Please enter a valid email address for ' + inputLabel;
    errorEl.textContent = message;
    errorEl.style.display = 'block';
    input.classList.add('error');
    input.setAttribute('aria-invalid', 'true');
    return false;
  }

  return true;
}

/**
 * Backward-compatible real-time email validation wrapper (used in markup oninput)
 */
function realTimeGiftSubscriptionEmailValidation(input) {
  return validateGiftField(input);
}

/**
 * Validate gift subscription fields on Add to Cart submit (vanilla JS)
 * Runs before the theme's submit handler, without editing native handlers.
 */
(function () {
  const productFormWrapper = document.querySelector('product-form');
  if (!productFormWrapper) return;

  const atcForm = productFormWrapper.querySelector('.js-product-form');
  if (!atcForm) return;

  // Disable native constraint validation so our custom validator can run on submit
  const initialGiftForm = productFormWrapper.querySelector('.gift-subscription__form');
  if (initialGiftForm) {
    atcForm.setAttribute('novalidate', 'novalidate');
  }

  // Attach a capturing listener so we can block the theme's submit handler if invalid
  atcForm.addEventListener(
    'submit',
    function (evt) {
      const giftForm = productFormWrapper.querySelector('.gift-subscription__form');
      if (!giftForm) return; // Only validate on gift subscription products

      // Clear previous errors
      const priorErrors = giftForm.querySelectorAll('.gift-subscription__error-message');
      priorErrors.forEach((el) => {
        if (el.dataset && el.dataset.generated === 'true') {
          el.remove();
        } else {
          el.textContent = '';
          el.style.display = 'none';
        }
      });
      giftForm.querySelectorAll('.error[aria-invalid="true"]').forEach((el) => {
        el.classList.remove('error');
        el.removeAttribute('aria-invalid');
      });

      const requiredInputs = Array.from(giftForm.querySelectorAll('[required]'));
      let hasError = false;
      let firstErrorField = null;

      requiredInputs.forEach((input) => {
        const valid = validateGiftField(input);
        if (!valid) {
          hasError = true;
          if (!firstErrorField) firstErrorField = input;
        }
      });

      if (hasError) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
        if (firstErrorField) {
          try {
            firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } catch (_) {}
          firstErrorField.focus({ preventScroll: true });
        }
      }
    },
    true // capture
  );
})();
